export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_39-a97945fc47e93038ab59918ad1da4aff.jpg";